import { lazy, Suspense, useState } from 'react'
import { Box, Fab } from '@mui/material'
import ChatBubbleOutlineIcon from '@mui/icons-material/ChatBubbleOutline'
import { useLanguage } from 'context/LanguageContext'
import { botLabels } from './labels'

const FaqDialog = lazy(() => import('./FaqDialog'))

export function FaqBot() {
  const { language } = useLanguage()
  const labels = botLabels[language]
  const [open, setOpen] = useState(false)
  const [loaded, setLoaded] = useState(false)

  return <>
    <Fab variant="extended" aria-label={labels.launcher} aria-haspopup="dialog"
      aria-expanded={open} aria-controls={open ? 'library-faq-dialog' : undefined}
      onClick={() => { setLoaded(true); setOpen(true) }}
      sx={{ position: 'fixed', bottom: 'max(24px, env(safe-area-inset-bottom))', right: 24,
        zIndex: 1200, bgcolor: 'var(--blue-500)', color: '#fff', fontSize: '1em',
        '&:hover': { bgcolor: '#af0000' } }}>
      <ChatBubbleOutlineIcon sx={{ mr: 1 }} />{labels.launcher}
    </Fab>
    {loaded && <Suspense fallback={<Box role="status" sx={{ position: 'fixed', right: 24,
      bottom: 90, zIndex: 1200, bgcolor: '#fff', p: 2, borderRadius: 2 }}>{labels.loading}</Box>}>
      <FaqDialog open={open} onClose={() => setOpen(false)} />
    </Suspense>}
  </>
}
